import type { DynamicCoreState } from '../types';

/**
 * The initial values for the state of the client.
 */
export const getInitialState = (): DynamicCoreState => ({
  captchaToken: null,
  elevatedAccessTokens: [],
  initStatus: 'uninitialized',
  legacyToken: null,
  mfaToken: null,
  prefetchedNonces: [],
  prefetchedNoncesExpiration: null,
  projectSettings: null,
  sessionExpiresAt: null,
  sessionKeys: null,
  token: null,
  unverifiedWalletAccounts: [],
  user: null,
  walletProviderKeyMap: {},
});
